<template>
  <div>
    <v-container fluid pa-0 grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h2 class="headline mr-2">Manage Restricted Users</h2>
              <v-icon :color="appButtonColor" @click="setRestricted">add_circle</v-icon>
              <v-spacer />
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                color="#0b2a4a"
              >
                <template v-slot:append>
                  <v-icon>search</v-icon>
                </template>
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="restricted"
              :rows-per-page-items="[15]"
              class="elevation-1 table-striped my-3"
              :pagination.sync="pagination"
              :search="search"
              :loading="searchLoading ? appButtonColor : searchLoading"
              :no-data-text="loadingText"
            >
              <template slot="items" slot-scope="props">
                <tr class="row">
                  <td>{{ props.item.a360id }}</td>
                  <td>{{ props.item.createdAt | moment("MM/DD/YYYY - h:mm a") }}</td>
                  <td>{{ props.item.attempts ? props.item.attempts : 'None' }}</td>
                  <td
                    v-if="props.item.lastAttempt"
                  >{{ props.item.lastAttempt | moment("MM/DD/YYYY - h:mm a") }}</td>
                  <td v-else>None</td>
                  <td class="delete">
                    <v-icon color="red" @click="remove(props.item.a360id)">cancel</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "Manage",
  data() {
    return {
      searchLoading: true,
      groupError: false,
      permSuccess: false,
      search: "",
      userPerms: ["Super", "Admin", "User"],
      headers: [
        { text: "A360ID", sortable: true, value: "a360id" },
        { text: "Created", sortable: true, value: "createdAt" },
        { text: "Sign Up Attempts", sortable: true, value: "attempts" },
        { text: "Last Attempt", sortable: true, value: "lastAttempt" },
        { text: "", value: "" },
      ],
      pagination: {
        descending: false,
        sortBy: "username",
      },
    };
  },
  computed: {
    ...mapState("user", ["user", "state", "confirmed", "mersBranded"]),
    ...mapState("accounts", ["restricted"]),
    ...mapGetters("user", ["isAuthenticated", "userGroup", "adminOrSuper"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    formatDate(date) {},
    loadingText() {
      if (this.searchLoading) return "Loading Restricted Users";
      else return "No Restricted Users Found";
    },
  },
  async created() {
    await this.$store.dispatch("accounts/getRestricted");
    this.searchLoading = false;
  },
  methods: {
    setRestricted() {
      this.$store.commit("accounts/setRestricted", true);
    },
    displayNotification(type, notification) {
      if (type === "success") {
        this.$snotify[type](`${notification}`);
      } else {
        this.$snotify[type](`${notification}`, "", {
          timeout: 0,
        });
      }
    },
    async remove(id) {
      let res = await this.$store.dispatch("accounts/removeRestricted", id);
      //   if (res) {
      //     this.displayNotification("success", "Restricted User Removed");
      //   } else {
      //     this.displayNotification("error", "Error Removing Restricted User");
      //   }
    },
  },
};
</script>

<style lang="scss">
.delete {
  text-align: right;
}
</style>
